// frontend/src/pages/Templates.jsx

import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import './styles/EBooks.css';

const DownloadTemplates = () => {
    const [fileUrl, setFileUrl] = useState('');

    const handleDownload = (tempFileName) => {
        const fileUrl = `${process.env.PUBLIC_URL}/fivewhystemplates/${tempFileName}`;
        download(fileUrl, tempFileName);
    };

    const download = (url, fileName) => {
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <div className="min-h-screen bg-black py-2">
            <div className='border-b border-blue-400 mb-2'>
                <h2 className="text-lg lg:text-xl font-extrabold text-center text-yellow-200 mb-2 p-2">
                📖 Download 5 Whys Analysis Printable Templates
                </h2>
            </div>
            <div className='min-h-[80vh]'>
                <div className="grid grid-cols-2 lg:grid-cols-5 gap-2 place-items-center">
                    <button className="bg-blue-500 text-white p-4 text-sm lg:text-m" onClick={() => handleDownload('T5WInfographics1.png')}>
                        Template 1
                    </button>
                    <button className="bg-blue-500 text-white p-4 text-sm lg:text-m" onClick={() => handleDownload('T5WInfographics2.png')}>
                        Template 2
                    </button>
                    <button className="bg-blue-500 text-white p-4 text-sm lg:text-m" onClick={() => handleDownload('T5WInfographics3.png')}>
                        Template 3
                    </button>
                    <button className="bg-blue-500 text-white p-4 text-sm lg:text-m" onClick={() => handleDownload('T5WInfographics4.png')}>
                        Template 4
                    </button>
                    <button className="bg-blue-500 text-white p-4 text-sm lg:text-m" onClick={() => handleDownload('T5WInfographics5.png')}>
                        Template 5
                    </button>
                </div>
            </div>
            <footer className="bg-black border-t border-blue-400 text-gray-400 py-4">
                <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
                <div className="text-sm">© 2025 Think5Whys Global DeepTech Solutions.</div>
                <div className="flex flex-wrap gap-4 text-sm">
                    <Link to="/about-us" className="hover:text-teal-300">About</Link>
                    <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
                    <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
                    <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
                </div>
                </div>
            </footer>              
        </div>
    );
};

export default DownloadTemplates;
